<template>
   <div class="right">
      <div class="title-box">
        <span class="curr">白皮书</span>
      </div>
      <div class="list flexH pt-30">
        <div class="item  mr-25" @click="jumpUrl(saiDiUrl)">
          <img src="@/assets/img/icon_book_img1.png" alt="">
        </div>
        <div class="item " @click="jumpUrl(aiRuiUrl)">
          <img src="@/assets/img/icon_book_img2.png" alt="">
        </div>
      </div>
   </div>
</template>
<script>
export default {
  data() {
    return {
      aiRuiUrl: 'https://xianniu-image-dev.oss-cn-beijing.aliyuncs.com/cms/files/20230419/168190941855859.pdf',
      saiDiUrl: 'https://xianniu-image-dev.oss-cn-beijing.aliyuncs.com/cms/files/20230419/168190947225632.pdf',
      leftList: [
        '专家智库',
        '主要职责',
        '分会专家',
        '白皮书',
      ]
    }
  },
  methods: {
    jumpUrl( url ){
      window.open(url, '_blank')
    }
  }
};
</script>
<style lang="less" scoped>

.right {
  width: 905px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
  padding: 30px;
  .item {
    width: 410px;
    height: 240px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.title-box {
  padding: 0 0 21px 0;
  border-bottom: 1px solid #f8f8fb;
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #909097;
    line-height: 28px;
    margin-right: 40px;
    position: relative;
    &.curr {
      color: #1b252c;
      &::after {
        width: 96px;
        height: 2px;
        background: #0d53bc;
        content: "";
        position: absolute;
        bottom: -20px;
        left: 0;
      }
    }
  }
}
</style>
